import { render, staticRenderFns } from "./main-gallery.vue?vue&type=template&id=50ac0d0c&scoped=true&"
import script from "./main-gallery.vue?vue&type=script&lang=js&"
export * from "./main-gallery.vue?vue&type=script&lang=js&"
import style0 from "./main-gallery.vue?vue&type=style&index=0&id=50ac0d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac0d0c",
  null
  
)

export default component.exports